import dayJs from 'dayjs'
import 'dayjs/locale/pt-br'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../components/clickstreamAnalise/clickstreamColeta.js'
import '../../css/pavFiltros/filtros.css'
import { api_gateway } from '../../conexoes/api'
import {
  filtrosArrayBarra,
  maximoTagsExibidas,
  mudarFiltros,
  recarregarBarraFiltragem,
  revelarBarraFiltragem
} from '../../redux/actions'
import { elipseVerde, fecharFiltroVerde } from '../../utils/alternanciaIcones'
import decryptJWT from '../../utils/decryptJWT'
import Checkbox from '../Mantine/Checkbox'
import DatePicker from '../Mantine/DatePicker/index.jsx'
import Select from '../Mantine/Select'

const arrOperadoras = [
  { value: '1', label: 'Claro' },
  { value: '5', label: 'Algar' },
  { value: '2', label: 'Vivo' },
  { value: '95', label: 'NEO (Rede Claro)' },
  { value: '4', label: 'Tim' },
  { value: '77', label: 'NEO (Rede Vivo)' },
  { value: '72', label: 'Arqia' }
]

const arrStatus = [
  { value: '2', label: 'Concluída' },
  { value: '1', label: 'Aberta' },
  { value: '4', label: 'Andamento' },
  { value: '3', label: 'Cancelada' }
]

export default function FiltrosFatSolicitacoes(props) {
  const [filtroDataInicial, setFiltroDataInicial] = useState('')
  const [filtroDataFinal, setFiltroDataFinal] = useState('')
  const [filtroOperadora, setFiltroOperadora] = useState('')
  const [filtroStatus, setFiltroStatus] = useState('')
  const [DsSolicitacaoTipo, setDsSolicitacaoTipo] = useState('')
  const [cdSolicitacaoTipo, setCdSolicitacaoTipo] = useState()
  const [dsFornecedor, setDsFornecedor] = useState('Selecione')
  const [cdFornecedor, setCdFornecedor] = useState()
  const [solicitacaoTipoLista, setSolicitacaoTipoLista] = useState([])
  const [filtroLoaded, setFiltroLoaded] = useState(false)

  const despacho = useDispatch()
  let recarregarBarraFiltragemValor = useSelector(
    (state) => state.filtrosState.recarregarBarraFiltragem
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  let arrayFiltrosSimcard = []

  async function handleCancelar() {
    props.setRevelarDropFiltros(false)
  }

  function convertValuesToLabels(valuesString, arrOptions) {
    if (!valuesString || valuesString === '') return ''

    const valuesArray = valuesString.split(',').map((v) => v.trim())
    const labelsArray = valuesArray
      .map((value) => {
        const option = arrOptions.find((op) => op.value === value)
        return option ? option.label : null
      })
      .filter((label) => label !== null)

    return labelsArray.join(',')
  }

  function hendlerGetdadosFiltros(listaTipos) {
    if (!filtros.vazio) {
      if (filtros.DATA_INICIO != '' && filtros.DATA_INICIO) {
        let auxData = new Date(filtros.DATA_INICIO)
        setFiltroDataInicial(auxData)
      }
      if (filtros.DATA_FIM != '' && filtros.DATA_FIM) {
        let auxData = new Date(filtros.DATA_FIM)
        setFiltroDataFinal(auxData)
      }

      if (filtros.TIPO_SOLICITACAO && filtros.TIPO_SOLICITACAO != '') {
        const found = listaTipos.find(
          (item) => item.label === filtros.TIPO_SOLICITACAO
        )
        setCdSolicitacaoTipo(found?.value || found?.id)
      }

      if (
        filtros.FORNECEDOR_SOLICITACAO &&
        filtros.FORNECEDOR_SOLICITACAO != ''
      )
        setCdFornecedor(filtros.FORNECEDOR_SOLICITACAO)

      if (filtros.STATUS && filtros.STATUS != '') {
        const statusLabels = convertValuesToLabels(filtros.STATUS, arrStatus)
        setFiltroStatus(statusLabels)
      }

      if (filtros.OPERADORA && filtros.OPERADORA != '') {
        const operadoraLabels = convertValuesToLabels(
          filtros.OPERADORA,
          arrOperadoras
        )
        setFiltroOperadora(operadoraLabels)
      }
    }
  }

  async function getSolicitacaoConectividadeTipos() {
    const { data } = await api_gateway.get(
      `/m1/consultar/tipo_solicitacao?cd_pav_cliente=${decryptJWT('codigoCliente')}`
    )
    const idFilter = [19]
    const arr = data.dados.filter(
      (item) => !idFilter.includes(item.cd_crm_solicitacao_tipo)
    )
    return arr.map((item) => ({
      value: item.cd_crm_solicitacao_tipo,
      label: item.ds_crm_solicitacao_tipo,
      nomeVeye: item.ds_crm_nome_veye
    }))
  }

  async function getSolicitacaoFaturasTipos() {
    const { data } = await api_gateway.get('/m1/consultar/fat_solicitacao_tipo')

    return data.dados.map((item) => ({
      id: item.cd_fat_solicitacao_tipo,
      value: item.cd_fat_solicitacao_tipo,
      label: item.ds_solicitacao_tipo
    }))
  }

  useEffect(() => {
    async function renderSolicitacaoTipos() {
      const urlPagina = window.location.href
      let transformedData

      if (urlPagina.includes('veye/solicitacoes/faturas')) {
        transformedData = await getSolicitacaoFaturasTipos()
      } else {
        transformedData = await getSolicitacaoConectividadeTipos()
      }

      setSolicitacaoTipoLista(transformedData)
      if (
        transformedData?.length &&
        filtros.TIPO_SOLICITACAO &&
        filtros.TIPO_SOLICITACAO != ''
      ) {
        let aux = transformedData.find(
          (solicitacao) => solicitacao.label == filtros.TIPO_SOLICITACAO
        )

        setDsSolicitacaoTipo(aux.label)
      }
      return transformedData
    }

    async function carregaFiltro() {
      const lista = await renderSolicitacaoTipos()
      hendlerGetdadosFiltros(lista)
      setFiltroLoaded(true)
    }
    carregaFiltro()
  }, [])

  useEffect(() => {
    if (solicitacaoTipoLista?.length && cdSolicitacaoTipo) {
      let solicita = solicitacaoTipoLista.find(
        (solicitacao) =>
          solicitacao.value === cdSolicitacaoTipo ||
          solicitacao.id === cdSolicitacaoTipo
      )
      if (solicita) {
        setDsSolicitacaoTipo(solicita.label)
      }
    }
  }, [solicitacaoTipoLista, cdSolicitacaoTipo])

  function handleFuncaoEstadosRedux() {
    const auxFilter = {}

    ColetaClickstream(1235) /*fatSolicitacoesTabelaDropFiltrosFiltrar*/
    if (
      filtroDataInicial !== '' &&
      filtroDataFinal !== '' &&
      filtroDataInicial &&
      filtroDataFinal &&
      moment(filtroDataInicial)._isValid &&
      moment(filtroDataFinal)._isValid
    ) {
      arrayFiltrosSimcard.push(
        'Data: ' +
          moment(filtroDataInicial).format('DD-MM-YYYY') +
          ' até ' +
          moment(filtroDataFinal).format('DD-MM-YYYY') +
          '?DATA_INICIO'
      )

      auxFilter.DATA_INICIO = filtroDataInicial
      auxFilter.DATA_FIM = filtroDataFinal
    }

    if (filtroStatus != '' && filtroStatus) {
      const valuesArray = []

      filtroStatus.split(',').forEach((label) => {
        const trimmedLabel = label.trim()
        if (trimmedLabel) {
          arrayFiltrosSimcard.push(`Status: ${trimmedLabel}?STATUS`)

          const status = arrStatus.find((op) => op.label === trimmedLabel)
          if (status) {
            valuesArray.push(status.value)
          }
        }
      })

      auxFilter.STATUS = valuesArray.join(',')
    }

    if (filtroOperadora != '' && filtroOperadora) {
      const valuesArray = []

      filtroOperadora.split(',').forEach((label) => {
        const trimmedLabel = label.trim()
        if (trimmedLabel) {
          const labelValidado = parseCheckboxLabel(trimmedLabel, arrOperadoras)
          if (labelValidado) {
            arrayFiltrosSimcard.push(`${labelValidado}`)

            const operadora = arrOperadoras.find(
              (op) => op.label === trimmedLabel
            )
            if (operadora) {
              valuesArray.push(operadora.value)
            }
          }
        }
      })

      auxFilter.OPERADORA = valuesArray.join(',')
    }

    if (cdSolicitacaoTipo != '' && cdSolicitacaoTipo) {
      arrayFiltrosSimcard.push(
        'Tipo: ' + DsSolicitacaoTipo + '?TIPO_SOLICITACAO'
      )

      auxFilter.TIPO_SOLICITACAO = DsSolicitacaoTipo
    }

    if (cdFornecedor != '' && cdFornecedor && dsFornecedor != 'Selecione')
      arrayFiltrosSimcard.push(
        'Fornecedor: ' + dsFornecedor + '?FORNECEDOR_SOLICITACAO'
      )

    props.setRevelarDropFiltros(false)
    despacho(mudarFiltros(auxFilter))
    despacho(maximoTagsExibidas(props.setRevelarDropFiltros))
    despacho(filtrosArrayBarra(arrayFiltrosSimcard))
    despacho(revelarBarraFiltragem(true))
    despacho(recarregarBarraFiltragem(!recarregarBarraFiltragemValor))
  }

  useEffect(() => {
    //Check se todas as variaveis estao limpas
    function handlerCheckarTudoLimpo(verificador = []) {
      if (filtroDataInicial == '') verificador.push(1)
      if (filtroDataFinal == '') verificador.push(1)
      //tamanho igual a quantidade de variaveis
      if (verificador.length === 4) return false
      else return true
    }

    async function handlerAtivarBotoes() {
      //se for alterado algo vai abilitar os botoes
      if (
        props.primeiraVez &&
        !props.foiLimpado &&
        (await handlerCheckarTudoLimpo())
      )
        props.setFoiSelecionado(true)
      else props.setFoiSelecionado(false)
    }

    //limpa os dados de todas as variaveis
    if (props.foiLimpado) {
      setFiltroDataInicial('')
      setFiltroDataFinal('')
      setFiltroOperadora('')
      setFiltroStatus('')
      setDsSolicitacaoTipo('')
      setCdSolicitacaoTipo()
      setDsFornecedor('')
      setCdFornecedor()
      props.setFoiLimpado(false)
    }

    handlerAtivarBotoes()
    props.setPrimeiraVez(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filtroDataInicial,
    filtroDataFinal,
    filtroStatus,
    filtroOperadora,
    cdSolicitacaoTipo,
    cdFornecedor,
    props.foiLimpado
  ])

  function dateHandler(newValue, time) {
    if (time == 'inicio') {
      setFiltroDataInicial(new Date(newValue))
    } else if (time == 'fim') {
      setFiltroDataFinal(new Date(newValue))
    }
  }

  return (
    <>
      {filtroLoaded && (
        <Form
          ref={props.modal}
          onSubmit={(e) => e.preventDefault()}
          className="drop-acoes-container-filtro-novo"
        >
          <div className="campo-select-triangulo-menor-cor-2-novo" />
          <div className="drop-acoes-corpo-filtro-novo fundo-cor-13">
            <div className="filtro-novo-header">
              <div className="filtro-novo-titulo">
                <img
                  className="filtro-novo-elipse-titulo"
                  src={elipseVerde()}
                />
                <div className="fonte-cor-1">Filtros</div>
              </div>
              <div className="filtro-novo-action-buttons">
                <div
                  onClick={props.limparFiltros}
                  className="filtro-novo-limpar-btn"
                >
                  <div className="filtro-green-text">LIMPAR FILTROS</div>
                  <img
                    className="filtro-limpar-icon"
                    src={fecharFiltroVerde()}
                  />
                </div>
                <div className="filtro-novo-btns">
                  <button
                    type="submit"
                    onClick={() => handleFuncaoEstadosRedux()}
                    className="filtrar-novo-btn"
                  >
                    FILTRAR
                  </button>
                  <div
                    onClick={() => handleCancelar()}
                    className="filtrar-novo-voltar-btn"
                  >
                    VOLTAR
                  </div>
                </div>
              </div>
            </div>
            <div className="filtro-novo-body fundo-cor-14">
              <div className="filtro-novo-body-section">
                <div className="filtro-novo-body-titulo fonte-cor-1">Tipo</div>
                <div className="filtro-novo-tipo-content">
                  <Select
                    searchable
                    width="270px"
                    placeholder="Selecione a solicitação"
                    value={cdSolicitacaoTipo}
                    onChange={(e) => {
                      setCdSolicitacaoTipo(e)

                      if (solicitacaoTipoLista?.length)
                        setDsSolicitacaoTipo(
                          solicitacaoTipoLista?.find((item) => item.value === e)
                            ?.label
                        )
                    }}
                    options={solicitacaoTipoLista}
                  />
                </div>
              </div>
              <div className="filtro-novo-body-section">
                <div className="filtro-novo-body-titulo fonte-cor-1">
                  Data de criação
                </div>
                <div className="filtro-novo-date-content">
                  <DatePicker
                    name="DATA_INICIO"
                    prefixo="De:"
                    value={filtroDataInicial ? dayJs(filtroDataInicial) : null}
                    onChange={(newValue) => dateHandler(newValue, 'inicio')}
                  />
                  <DatePicker
                    name="DATA_FIM"
                    prefixo="Até:"
                    maxDate={new Date()}
                    value={filtroDataFinal ? dayJs(filtroDataFinal) : null}
                    onChange={(newValue) => dateHandler(newValue, 'fim')}
                  />
                </div>
              </div>

              <ListCheckbox
                title="Operadora"
                valorAtual={filtroOperadora}
                setValor={setFiltroOperadora}
                arrOpcoes={arrOperadoras}
              />
              <ListCheckbox
                title="Status"
                valorAtual={filtroStatus}
                setValor={setFiltroStatus}
                arrOpcoes={arrStatus}
              />
            </div>
          </div>
        </Form>
      )}
    </>
  )
}

function ListCheckbox({
  title,
  valorAtual,
  setValor,
  arrOpcoes,
  className = ''
}) {
  function onChangeCheckbox(label, checked) {
    const stateArray = valorAtual
      ? valorAtual.split(',').filter((op) => op !== '')
      : []
    let res

    if (checked) {
      if (!stateArray.includes(label)) {
        stateArray.push(label)
      }
      res = stateArray.join(',')
    } else {
      const updatedStateArray = stateArray.filter((lbl) => lbl !== label)
      res = updatedStateArray.join(',')
    }

    setValor(res)
  }

  return (
    <div className={`filtro-novo-body-section ${className}`}>
      <div className="filtro-novo-body-titulo fonte-cor-1">{title}</div>
      <div className="filtro-novo-checkbox-content">
        {arrOpcoes.map(({ label, value }) => {
          const selecionado = isSelecionado(valorAtual, label)

          return (
            <Checkbox
              key={value}
              label={label}
              checked={selecionado}
              onChange={(event) => {
                onChangeCheckbox(label, event.currentTarget.checked)
              }}
            />
          )
        })}
      </div>
    </div>
  )
}

function parseCheckboxLabel(option, arrOptions) {
  const objOption = arrOptions.find((op) => op.label === option)

  if (objOption) {
    return objOption.label
  }
}

const isSelecionado = (arr, label) => {
  if (!arr || arr === '') return false
  return arr.split(',').some((op) => op.trim() === label)
}
